import { ExportButton } from '@/common/buttons/ExportButton';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { IconUtils } from '@/common/utils/IconUtils';
import { useMemo } from 'react';
import { Title } from '../../title/Title';
import { useTab } from '../entityDetail/TabContext';
import { useEntityMgr } from '../entityView/EntityMgrContext';
import { EntityFormMode } from '../enumerations/EntityFormMode';

export const EntityTitle = ({ buttons }) => {
  const { entityDef, exportReq, hist, entityObj, entityFormMode, breadcrumbs } = useEntityMgr();

  const { tabId } = useTab();
  const inDialog = useInDialog();

  const icon = useMemo(
    () => IconUtils.iconFromIconStr(entityDef.icon),
    [entityDef.icon]
  );

  let title = entityDef
    ? entityDef.displayName + (hist ? ' History' : '')
    : null;
  title = tabId ? null : title;

  const defaultBreadcrumbs = useMemo(() => {
    if (!entityObj || Object.keys(entityObj).length === 0) return null;
    return [entityObj.name ?? entityObj.code];
  }, [entityObj?.name, entityObj?.code]);



  if ((!entityFormMode || entityFormMode !== EntityFormMode.ADD)) {
    buttons = [...buttons, <ExportButton key="export" exportReq={exportReq} />]
  }

  return (
    !inDialog && <Title
      icon={icon}
      title={title}
      breadcrumbs={breadcrumbs ?? defaultBreadcrumbs}
      buttons={buttons}
    />
  );
};
